import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */

const SvgViber = forwardRef((props: Props, svgRef: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1.5em"
    height="1.5em"
    fill="none"
    viewBox="0 0 24 24"
    ref={svgRef}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.65 4.43c-.227-.269-.517-.414-.84-.414L6.816 4h-.022c-.2 0-.42.058-.638.18a6.164 6.164 0 00-1.528 1.244H4.62c-.359.44-.57.86-.61 1.258 0 .015-.003.03-.005.048-.004.038-.01.084.004.14-.02.18.02.36.08.54h.022c.18.64.64 1.7 1.62 3.46a21.766 21.766 0 001.918 2.92c.342.426.72.866 1.162 1.307l.038.037.04.04.102.038c.44.441.88.821 1.3 1.161.82.66 1.78 1.3 2.92 1.94 1.76.98 2.82 1.44 3.46 1.62v.019c.18.042.36.082.54.082a.361.361 0 00.14.004l.04-.004c.42-.04.84-.24 1.26-.6h.01c.524-.48.939-.98 1.245-1.52v-.022c.3-.56.2-1.118-.24-1.479l-.122-.1c-.267-.221-.908-.751-1.26-1a13.797 13.797 0 00-1.487-.94c-.681-.379-1.375-.139-1.659.241l-.6.76c-.306.38-.873.328-.873.328-4.158-1.062-5.278-5.272-5.278-5.272s-.047-.565.333-.87l.755-.6c.368-.288.609-.984.229-1.664-.213-.38-.635-1.06-.948-1.487A38.6 38.6 0 007.649 4.43zm10.986 6.795c-.495-3.921-2.29-5.772-6.184-6.37a2.47 2.47 0 00-.206-.021c-.29-.021-.603-.044-.584-.386.028-.483.376-.46.665-.44.088.006.171.012.238.003 3.74.126 6.96 3.55 6.914 7.242-.001.06.002.124.005.19.015.334.031.708-.42.7-.404-.009-.41-.344-.415-.663a2.288 2.288 0 00-.013-.255zm-5.598-5.322c.06.01.12.02.176.026 2.402.289 4.364 2.373 4.345 4.663-.01.066-.007.143-.004.224.009.25.018.527-.313.577-.473.072-.494-.261-.513-.575a2.247 2.247 0 00-.02-.224c-.396-2.385-1.234-3.26-3.638-3.797a2.231 2.231 0 00-.217-.036c-.323-.044-.67-.092-.597-.534.075-.441.443-.38.781-.324zm.396 1.899c-.25.006-.495.033-.587.3-.138.4.153.494.448.542.986.158 1.505.74 1.604 1.723.027.267.196.484.454.453.357-.042.39-.36.379-.662.017-1.106-1.232-2.383-2.297-2.356z"
      clipRule="evenodd"
    />
  </svg>
));
SvgViber.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgViber;
